import { BaseFieldComponent } from '../base-field/base-field.component';
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'forms-floating',
  templateUrl: './floating.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FloatingComponent),
      multi: true,
    },
  ],
})
export class FloatingComponent extends BaseFieldComponent {
  @Input() decimalSeparator: string = ',';
  public displayValue: string = '';

  writeValue(value: any): void {
    if (value !== null && !Number.isNaN(value)) {
      this.displayValue = value.toString().replace('.', this.decimalSeparator);
    }
    this.value = value;
  }

  public mask(input: HTMLInputElement) {
    if (input.value === '') {
      super.writeValue(null);
    } else {
      input.value = this.filterInput(input.value);
      this.value = parseFloat(input.value.replace(this.decimalSeparator, '.'));
    }
  }

  private filterInput(value: string): string {
    const sign = value[0] === '-' ? '-' : '';
    const regexStr = '[^\\d' + (this.decimalSeparator === '.' ? '\\.' : this.decimalSeparator) + ']';
    value = value.replace(new RegExp(regexStr, 'g'), '');

    if (value.indexOf(this.decimalSeparator) > -1) {
      let [integerPart, decimalPart] = value.split(this.decimalSeparator);
      return sign + (integerPart || '') + this.decimalSeparator + (decimalPart || '');
    }

    return sign + value;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/floating/floating.component.ts